import { Route, Routes } from "react-router-dom";
import ClientsPage from "../../pages/shared-pages/clients/ClientsPage";
import ClientDetailsPage from "../../pages/shared-pages/clients/ClientDetailsPage";

export default function ClientNav() {
  return (
    <Routes>
   
               <Route path="/" element={<ClientsPage />} />
               <Route path="/details" element={<ClientDetailsPage />} />
   
           </Routes>
  )
}
